import axios from 'axios';
import { getStorage } from './localstorage';

axios.interceptors.request.use(
  (config) => {
    const authToken = getStorage('token');
    config.headers.common.Authorization = `Bearer ${authToken}`;
    return config;
  },
  (error) => Promise.reject(error),
);

export default axios;
